
import thunk from "redux-thunk";
import Security from "../security";
import { combineReducers, createStore, applyMiddleware } from "redux";
import { SignUpActions, SignUpReducer } from "./signup";
import { CreateAdminActions, CreateAdminReducer } from "../store/CreateAdmin";

import { SignOutActions, SignOutReducer } from './signOut';
import { SchoolInformationActions, SchoolInformationReducer } from './schoolInformation'
import { UserProfileActions, UserProfileReducer } from './userProfile/index';
import { AddGradeActions, AddGradeReducer } from './grade/index'
import { TeacherActions, TeacherReducer } from './teacher'
import { SubjectActions, SubjectReducer } from './subject/index'
import { SharedRoomActions, SharedRoomReducer } from './sharedRoom/index'
import { ContextualHelpActions, ContextualHelpReducer } from './contextualHelp'
import { PricingActions, PricingReducer } from './pricing'
import { SubscriptionActions, SubscriptionReducer } from './subscription'
import signUpReducer from "./signup/SignUpReducer";
import { ErrorLogActions, ErrorLogReducer } from './errorLog'
import { TimeTableActions, TimeTableReducer } from './timeTable'
import { SystemConfigActions, SystemConfigReducer } from './systemConfig'
import { OrderActions, OrderReducer } from './order'
import I18nMessagesReducer from "../i18n/I18nReducer";
import * as I18nActions from '../i18n/I18nActions';

const reducers = combineReducers({
  cognito: Security.securityStore,
  createAdmin: CreateAdminReducer,
  schoolInformation: SchoolInformationReducer,
  userProfile: UserProfileReducer,
  gradeInformation: AddGradeReducer,
  TeachersInformation: TeacherReducer,
  subjectInformation: SubjectReducer,
  SharedRoomInformation: SharedRoomReducer,
  TeachersInformation: TeacherReducer,
  contextualHelp: ContextualHelpReducer,
  i18nMessages: I18nMessagesReducer,
  signUpReducer: signUpReducer,
  Pricing: PricingReducer,
  Subscription: SubscriptionReducer,
  errorLog: ErrorLogReducer,
  timeTable: TimeTableReducer,
  systemConfig: SystemConfigReducer,
  order: OrderReducer
});
let store = createStore(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  applyMiddleware(thunk)
);
Security.initialize(store);

export default store;

export { SignOutActions, SignUpActions, CreateAdminActions, SchoolInformationActions, UserProfileActions, AddGradeActions, SubjectActions, TeacherActions, SharedRoomActions, ContextualHelpActions, PricingActions, SubscriptionActions, ErrorLogActions, TimeTableActions, SystemConfigActions, OrderActions, I18nActions };





